import {
  CreditEngineWhitelistBlacklist,
  GetWhitelistParams,
  WhitelistPaginatedResponse,
  WhitelistItem,
} from "@/models/consignado/whitelistBlacklist.model";
import { axiosConsignadoInstance } from "../axiosInstance";

export const getWhitelistBlacklist = async (
  params: GetWhitelistParams,
): Promise<WhitelistPaginatedResponse> => {
  try {
    const response = await axiosConsignadoInstance.get(
      "/api-consignado-trabalhador/v1/motor-credito/whitelist-blacklist",
      { params },
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar whitelist/blacklist de CNPJs", error);
    throw error;
  }
};

export const addWhitelistCnpj = async (
  payload: CreditEngineWhitelistBlacklist,
): Promise<WhitelistItem> => {
  try {
    const response = await axiosConsignadoInstance.post(
      "/api-consignado-trabalhador/v1/motor-credito/whitelist-blacklist",
      payload,
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao adicionar CNPJ na whitelist/blacklist", error);
    throw error;
  }
};

export const deleteWhitelistCnpj = async (id: string): Promise<void> => {
  try {
    await axiosConsignadoInstance.delete(
      `/api-consignado-trabalhador/v1/motor-credito/whitelist-blacklist/${id}`,
    );
  } catch (error) {
    console.error("Erro ao deletar CNPJ da whitelist/blacklist", error);
    throw error;
  }
};
